import { success, failure, request } from 'app/actions';
import * as actions from './simulatedEditionActions';

const initialState = {
  isCoordinator: { permission: null, edit: null },
  permission: 0,
  edit: 0,
  loader: false,
  errorMessageDownload: false,
  errorMessageGenerateEvaluationAnswerSheetFiles: false,
  evaluationOnlineDates: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case request(actions.CHECK_COORDINATOR_PERMISSION_EVALUATION):
      return { ...state, permission: initialState.permission, edit: initialState.edit };
    case success(actions.CHECK_COORDINATOR_PERMISSION_EVALUATION):
      const { permission, edit } = action.payload.contents.isCoordinator;
      return { ...state, permission, edit };

    case request(actions.DOWNLOAD_PDF):
      return { ...state, loader: true, errorMessageDownload: initialState.errorMessageDownload };
    case success(actions.DOWNLOAD_PDF):
      return {
        ...state,
        loader: initialState.loader,
        errorMessageDownload: initialState.errorMessageDownload,
      };
    case failure(actions.DOWNLOAD_PDF):
      return { ...state, errorMessageDownload: true, loader: initialState.loader };

    case request(actions.GENERATE_EVALUATION_ANSWER_SHEET_FILES):
      return {
        ...state,
        loader: true,
        errorMessageGenerateEvaluationAnswerSheetFiles:
          initialState.errorMessageGenerateEvaluationAnswerSheetFiles,
      };
    case success(actions.GENERATE_EVALUATION_ANSWER_SHEET_FILES):
      return {
        ...state,
        errorMessageGenerateEvaluationAnswerSheetFiles:
          initialState.errorMessageGenerateEvaluationAnswerSheetFiles,
      };
    case failure(actions.GENERATE_EVALUATION_ANSWER_SHEET_FILES):
      return {
        ...state,
        errorMessageGenerateEvaluationAnswerSheetFiles: true,
        loader: initialState.loader,
      };
    case request(actions.GET_EVALUATION_ONLINE_IN_PROGRESS):
      return { ...state, loader: true };
    case success(actions.GET_EVALUATION_ONLINE_IN_PROGRESS):
      return {
        ...state,
        loader: initialState.loader,
        evaluationOnlineDates: action.payload.content,
      };
    default:
      return state;
  }
};

export default reducer;
